
import PostLoginLayout from "../components/layouts/PostLoginLayout";
import ClientsComponent from "../components/ClientsComponent";

const Clients = () => {
  let ClientsContainer = <ClientsComponent />;

  return <PostLoginLayout childComponent={ClientsContainer} noLeftPanel={false} loader={false}/>;
};

export default Clients;
